import date from './date'
import session from './session'
import string from './string'
import publicFun from './publicFun'

export default {
  date,
  session,
  string,
  publicFun
}



// WEBPACK FOOTER //
// ./src/utils/index.js